import React from "react";
import { Mail, Phone, MapPin, ArrowUpRight, Linkedin } from "lucide-react";

export default function Contact() {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative py-28 md:py-40 border-t border-[#e8e4dd] bg-white overflow-hidden"
        >
            <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
                <p className="label-eyebrow mb-8">— 06 / Contact</p>
                <h2
                    className="font-serif text-[#0e0e0c] tracking-tight leading-[0.98]"
                    style={{
                        fontSize: "clamp(56px, 9vw, 156px)",
                        fontWeight: 300,
                    }}
                >
                    Parlons de votre <br />
                    <span className="italic-serif" style={{ fontWeight: 400 }}>
                        prochaine campagne.
                    </span>
                </h2>

                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#e8e4dd] border border-[#e8e4dd]">
                    <a
                        href="mailto:quentinsoulton@gmail.com"
                        data-testid="contact-email"
                        className="bg-white p-8 hover:bg-[#fbfaf7] transition-colors group flex items-start justify-between"
                    >
                        <div>
                            <div className="flex items-center gap-2 label-eyebrow mb-4">
                                <Mail size={12} /> Courriel
                            </div>
                            <p className="font-serif text-2xl text-[#0e0e0c] break-all">
                                quentinsoulton@gmail.com
                            </p>
                        </div>
                        <ArrowUpRight
                            size={20}
                            className="text-[#9a9890] group-hover:text-[#0e0e0c] transition-colors shrink-0 ml-3 group-hover:rotate-45 duration-500"
                        />
                    </a>
                    <a
                        href="tel:+33749199423"
                        data-testid="contact-phone"
                        className="bg-white p-8 hover:bg-[#fbfaf7] transition-colors group flex items-start justify-between"
                    >
                        <div>
                            <div className="flex items-center gap-2 label-eyebrow mb-4">
                                <Phone size={12} /> Téléphone
                            </div>
                            <p className="font-serif text-2xl text-[#0e0e0c]">
                                +33 7 49 19 94 23
                            </p>
                        </div>
                        <ArrowUpRight
                            size={20}
                            className="text-[#9a9890] group-hover:text-[#0e0e0c] transition-colors shrink-0 ml-3 group-hover:rotate-45 duration-500"
                        />
                    </a>
                    <div
                        data-testid="contact-loc"
                        className="bg-white p-8 flex items-start"
                    >
                        <div>
                            <div className="flex items-center gap-2 label-eyebrow mb-4">
                                <MapPin size={12} /> Localisation
                            </div>
                            <p className="font-serif text-2xl text-[#0e0e0c]">
                                Paris, France
                            </p>
                            <p className="text-sm text-[#6b6b66] italic-serif mt-1">
                                Disponible en remote ou sur site (Europe)
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-12 flex flex-wrap items-center gap-4">
                    <a
                        href="mailto:quentinsoulton@gmail.com?subject=Mission%20SEA%2FSMA"
                        data-testid="contact-cta-primary"
                        className="btn-primary"
                    >
                        Démarrer un projet ensemble
                        <ArrowUpRight size={14} />
                    </a>
                    <a
                        href="https://www.linkedin.com/in/lionel-soulton"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-cta-linkedin"
                        className="btn-ghost"
                    >
                        <Linkedin size={14} /> LinkedIn
                    </a>
                </div>
            </div>
        </section>
    );
}
